/* eslint-disable jsx-a11y/mouse-events-have-key-events */

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars';
import SwiperCore, { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.scss';
import moment from 'moment';

import { Preloader } from '../preloader';
import TicketItem from './ticket';
import { API_SERVER } from '../../constans/api';
import { ReactComponent as ArrowIcon } from '../../assets/arrow.svg';
import { ReactComponent as InfoIcon } from '../../assets/info-border.svg';
import { ReactComponent as PulseIcon } from '../../assets/pulse-line.svg';
import './style.scss';

SwiperCore.use([Navigation]);

class ScheduleByDay extends React.Component {
    constructor() {
        super();

        this.swiper = null;
        this.state = {
            navigationActive: {
                prev: false,
                next: true
            }
        };
    }

    isTimeTicketPassed = (doctorTicket) => {
        const { schedule } = this.props;
        const { time } = schedule;
        const isToday = moment(doctorTicket.date_ticket).format('DD.MM.YYYY') === moment().format('DD.MM.YYYY');
        const timePassed = isToday && time >= +moment(doctorTicket.time_start).format('Hmm');

        return timePassed;
    }

    onInitSwiper = (swiper) => {
        this.swiper = swiper;

        if (window.matchMedia('(min-width: 991px)').matches && swiper.slides.length === 4) {
            this.setState({
                navigationActive: {
                    prev: false,
                    next: false
                }
            });
        } else if (window.matchMedia('(max-width: 991px)').matches && swiper.slides.length === 2) {
            this.setState({
                navigationActive: {
                    prev: false,
                    next: false
                }
            });
        }

        this.swiper.on('slideChange', () => {
            if (this.swiper.isBeginning) {
                this.setState({
                    navigationActive: {
                        prev: false,
                        next: true
                    }
                });
            } else if (this.swiper.isEnd) {
                this.setState({
                    navigationActive: {
                        prev: true,
                        next: false
                    }
                });
            } else {
                this.setState({
                    navigationActive: {
                        prev: true,
                        next: true
                    }
                });
            }
        });
    }

    onNavigation = (type) => {
        switch (type) {
            case 'prev':
                this.swiper.slidePrev();
                break;
            case 'next':
                this.swiper.slideNext();
                break;
            default:
                break;
        }
    }

    onMobileScroll = (ref) => {
        const elem = ref.current;
        const scrolled = elem.scrollTop;
        elem.scrollTop = scrolled + 50;
    }

    render() {
        const { navigationActive } = this.state;
        const { schedule } = this.props;
        const { data: dataSchedule, settings } = schedule;

        const placeholder = settings && settings.placeholder ? `${API_SERVER}${settings.placeholder}` : '//module.vpriem.ru/app/dist/assets/placeholder.jpg';
        const isMobile = window.matchMedia('(max-width: 991px)').matches;

        if (dataSchedule) {
            let emptyDocotrs = 0;
            let sortingDoctorsByLoad = [];
            dataSchedule.forEach((doctor) => {
                if (!doctor.tickets.data.length) {
                    emptyDocotrs++;
                } else {
                    const availibleTicketsDoctor = doctor.tickets.data.filter((doctorTicket) => {
                        if (+doctorTicket.is_hidden) return false;
                        if (doctorTicket.write_id) return false;
                        return true;
                    });
                    if (availibleTicketsDoctor.length === 0) {
                        emptyDocotrs++;
                    }
                    sortingDoctorsByLoad = [...sortingDoctorsByLoad, { id: doctor.id, availibleTickets: availibleTicketsDoctor.length }];
                }
            });

            if (emptyDocotrs === dataSchedule.length) {
                return (
                    <div className="schedule__by-days">
                        <div className="schedule__scroll-container">
                            <div className="schedule__scroll">
                                <p className="schedule_empty day">
                                    ~ Нет талонов ~
                                </p>
                            </div>
                        </div>
                    </div>
                );
            }

            sortingDoctorsByLoad.sort((a, b) => {
                if (a.availibleTickets > b.availibleTickets) return -1;
                if (a.availibleTickets < b.availibleTickets) return 1;
                return 0;
            });

            return (
                <>
                    <div className="schedule__by-days">
                        <div className="schedule__by-days__navigation">
                            <button type="button" className="schedule__by-days__navigation_prev" onClick={() => this.onNavigation('prev')} disabled={!navigationActive.prev}><ArrowIcon /></button>
                            <button type="button" className="schedule__by-days__navigation_next" onClick={() => this.onNavigation('next')} disabled={!navigationActive.next}><ArrowIcon /></button>
                        </div>
                        <div className="schedule__scroll-container">
                            <div className="schedule__scroll">
                                <div className="schedule__by-days_pulse-icon">
                                    <PulseIcon />
                                </div>
                                <Swiper
                                    onSwiper={(swiper) => {
                                        const newSwiper = swiper;
                                        if (!isMobile) {
                                            newSwiper.allowTouchMove = false;
                                        }
                                        this.onInitSwiper(newSwiper);
                                    }}
                                    spaceBetween={0}
                                    breakpoints={{
                                        991: {
                                            slidesPerView: 4
                                        },
                                        375: {
                                            slidesPerView: 2
                                        },
                                        320: {
                                            slidesPerView: 1
                                        }
                                    }}
                                    slidesPerView={2}
                                >
                                    {sortingDoctorsByLoad.map((doctorSorted) => {
                                        const doctor = dataSchedule.filter(item => +item.id === +doctorSorted.id)[0];
                                        const refScroll = React.createRef();
                                        const refDescription = React.createRef();

                                        if (doctor.tickets.data.length) {
                                            let availibleTicketsDoctor = doctor.tickets.data.map((doctorTicket) => {
                                                const timePassed = this.isTimeTicketPassed(doctorTicket);

                                                if (timePassed) return null;
                                                if (+doctorTicket.is_hidden) return null;
                                                if (doctorTicket.write_id) return null;
                                                return <TicketItem key={`ticket-${doctor.id}-${doctorTicket.time_start}-${doctorTicket.time_end}`} doctor={doctor} ticket={doctorTicket} />;
                                            });

                                            availibleTicketsDoctor = availibleTicketsDoctor.filter(doctorTicket => doctorTicket !== null);

                                            if (availibleTicketsDoctor.length) {
                                                return (
                                                    <SwiperSlide key={`doctor-${doctor.id}`}>
                                                        <div className="schedule__by-days__item">
                                                            <div className="schedule__by-days__item_photo" style={{ backgroundImage: `url('${doctor.photo !== '' ? `${API_SERVER}${doctor.photo}` : placeholder}')` }} />
                                                            <div className="tooltip" ref={refDescription}>
                                                                <strong>Ф.И.О.:</strong>
                                                                <span>{`${doctor.last_name} ${doctor.first_name} ${doctor.second_name}`}</span>
                                                                <strong>Филиал:</strong>
                                                                <span>{doctor.filials.map(item => item.name).join(', ')}</span>
                                                                <strong>Специальность:</strong>
                                                                <span>{doctor.services.join(', ')}</span>
                                                            </div>
                                                            <span
                                                                className="schedule__by-days__item_name"
                                                                onMouseOver={() => {
                                                                    refDescription.current.classList.add('show');
                                                                }}
                                                                onMouseLeave={() => {
                                                                    refDescription.current.classList.remove('show');
                                                                }}
                                                            >
                                                                {doctor.last_name}
                                                                <br />
                                                                {doctor.first_name}
                                                                <InfoIcon />
                                                            </span>
                                                            <div className="schedule__by-days__item__tickets">
                                                                {window.matchMedia('(max-width: 991px)').matches ? (
                                                                    <div className="schedule__by-days__item__tickets-scroll" ref={refScroll}>
                                                                        {availibleTicketsDoctor.map(doctorTicket => (doctorTicket))}
                                                                    </div>
                                                                ) : (
                                                                    <Scrollbars
                                                                        style={{ height: 270 }}
                                                                        className="scrollbar"
                                                                        renderThumbVertical={props => <div {...props} className="scrollbar-thumb-vertical" />}
                                                                        renderTrackVertical={props => <div {...props} className="scrollbar-track-vertical" />}
                                                                        autoHide={false}
                                                                    >
                                                                        {availibleTicketsDoctor.map(doctorTicket => (doctorTicket))}
                                                                    </Scrollbars>
                                                                )}
                                                                {(window.matchMedia('(max-width: 991px)').matches && availibleTicketsDoctor.length > 5) && (
                                                                    <button
                                                                        type="button"
                                                                        className="schedule__by-days__item__tickets__down"
                                                                        onClick={() => this.onMobileScroll(refScroll)}
                                                                    >
                                                                        <ArrowIcon />
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </SwiperSlide>
                                                );
                                            }
                                            return null;
                                        }
                                        return null;
                                    })}
                                </Swiper>
                            </div>
                        </div>
                    </div>
                </>
            );
        }
        return <Preloader />;
    }
}

ScheduleByDay.propTypes = {
    schedule: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    schedule: state.schedule
});

export default connect(mapStateToProps)(ScheduleByDay);
